import api from './api';

export async function getCustomerGodView(id: string, params?: {
  tab?: string; search?: string; status?: string; from?: string; to?: string; page?: number; limit?: number;
}) {
  const res = await api.get(`/admin/customers/${id}/god-view`, { params });
  return res.data.data as {
    customer: {
      _id: string; name: string; firstName?: string; lastName?: string; email?: string; phone?: string;
      username?: string; status?: string; userType?: string; isVerified?: boolean;
      isBlocked?: boolean; blockedReason?: string; statusDetail?: string;
    };
    stats: {
      rating: number; ratingCount: number; tripCount: number; orderCount: number;
      spend: number; walletBalance: number; loyaltyPoints: number; loyaltyTier?: string;
    };
    tab: string;
    rows: Record<string, unknown>[];
    total: number;
  };
}

export async function getTripGodView(id: string) {
  const res = await api.get(`/admin/trips/${id}/god-view`);
  return res.data.data as {
    kind: string;
    trip: Record<string, unknown>;
    customer: { _id: string; name: string; email?: string; phone?: string } | null;
    driver: { _id: string; name: string; email?: string; phone?: string } | null;
    timeline: Array<{ key: string; label: string; at: string }>;
    ratings: Array<Record<string, unknown>>;
    fields: Array<[string, string]>;
  };
}

export async function getOrderGodView(id: string) {
  const res = await api.get(`/admin/orders/${id}/god-view`);
  return res.data.data as {
    _id: string;
    kind: string;
    orderNumber: string;
    status: string;
    total: number;
    paymentMethod?: string;
    paymentStatus?: string;
    createdAt?: string;
    pickup?: string;
    drop?: string;
    customer: { _id: string; name: string; email?: string; phone?: string } | null;
    partner: { _id: string; name: string; email?: string; phone?: string } | null;
    items: Array<{ _id: string; name: string; qty: number; price: number; total: number }>;
    timeline: Array<{ key: string; label: string; at?: string; note?: string }>;
    fare: Record<string, unknown>;
    fields: Array<[string, string]>;
  };
}
